/**
 * Copyright 2020 (c) Dominik Basner, Sotec GmbH (for VDW e.V.)
 * Copyright 2020 (c) Fabian Wilhelm, Sotec GmbH (for VDW e.V.)
 * Copyright 2020-2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import React, { Component } from 'react';

class PageHero extends Component {
  render() {
    return (
      <div className="hero hero-page">
        <div className="container">
          <h2 className="display-4 mb-0">{this.props.title}</h2>
        </div>
      </div>
    );
  }
}

export default PageHero;
